import "./Index.css";

import * as React from "react";

interface IIndexProps {}

export default class Index extends React.Component<IIndexProps, {}> {

    public constructor(props: IIndexProps) {
        super(props);
    }

    public render() {
        return (
            <div className="Index">
                <div className="Index__navigation">
                    <img src="assets/heart.png"/>
                </div>
                <div className="Index__name">
                    <span>HERZ</span>WEG
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Index.tsx